import FootballTransition from "./football-transition";
import FootballState from "./football-state";

const FootballTransitionConfig = [
    {
        name: FootballTransition.Spike,
        from: [FootballState.AddPlay],
        to: FootballState.Spike
    },
    {
        name: FootballTransition.KneelDown,
        from: [FootballState.AddPlay],
        to: FootballState.KneelDown
    },
    // Fumbled Snap
    {
        name: FootballTransition.FumbledSnap,
        from: [FootballState.AddPlay],
        to: FootballState.FumbledSnap
    },
    {
        name: FootballTransition.FumbledSnapLost,
        from: [FootballState.FumbledSnap],
        to: FootballState.FumbledSnapLost
    },
    {
        name: FootballTransition.FumbledSnapRecovered,
        from: [FootballState.FumbledSnap],
        to: FootballState.FumbledSnapRecovered
    },
    {
        name: FootballTransition.AddPlay,
        from: FootballState.Start,
        to: FootballState.AddPlay
    },
    {
        name: FootballTransition.Rush,
        from: [FootballState.AddPlay, FootballState.FumbledSnapRecovered],
        to: FootballState.Rush
    },
    {
        name: FootballTransition.EndOfPlay,
        from: [
            FootballState.Rush,
            FootballState.Run,
            FootballState.FieldGoalFakeRun,
            FootballState.FumbleRecovered,
            FootballState.FumbleNotRecovered,
            FootballState.Continue,
            FootballState.Returned,
            FootballState.NoRecoveryKickReturn,
            FootballState.Tackle,
            FootballState.OutOfBounds,
            FootballState.PatCompleted,
            FootballState.PatMissed,
            FootballState.PatFumbled,
            FootballState.Rouge,
            FootballState.Downed,
            FootballState.TouchBack,
            FootballState.FairCatch,
            FootballState.KickRecovered,
            FootballState.KickNotRecovered,
            FootballState.PassIntercepted,
            FootballState.PassComplete,
            FootballState.PassIncomplete,
            FootballState.PassBrokenUp,
            FootballState.PassDropped,
            FootballState.PassSacked,
            FootballState.PenaltyDeclined,
            FootballState.NoPlay,
            FootballState.PuntOutOfBounds,
            FootballState.FieldGoalOutOfBounds,
            FootballState.Lateral,
            FootballState.Safety,
            FootballState.KickOffPenaltyDeclined,
            FootballState.FieldGoalGood,
            FootballState.FieldGoalMissed,
            FootballState.FieldGoalBlocked,
            FootballState.DeuceGood,
            FootballState.DeuceMissed,
            FootballState.ReboundNetCaughtOffense,
            FootballState.ReboundNetCaughtDefense,
            FootballState.ReboundNetHitGround,
            FootballState.ReboundNetFieldedKicking,
            FootballState.ReboundNetFieldedReceiving,
            FootballState.BarBallRecoveredKicking,
            FootballState.BarBallRecoveredReceiving,
            FootballState.PatBlocked,
            FootballState.PatPointsAwarded,
            FootballState.PatPointsNotAwarded,
            FootballState.PatRecovered,
            FootballState.PatNotRecovered,
            FootballState.PatIntercepted,
            FootballState.Spike,
            FootballState.KneelDown,
            FootballState.FumbledSnapLost,
            FootballState.FumbledSnapRecovered
        ],
        to: FootballState.EndOfPlay
    },
    {
        name: FootballTransition.KickOffPenaltyAccepted,
        from: FootballState.KickOffPenalty,
        to: FootballState.KickOffPenaltyAccepted
    },
    {
        name: FootballTransition.KickOffPenaltyDeclined,
        from: FootballState.KickOffPenalty,
        to: FootballState.KickOffPenaltyDeclined
    },
    {
        name: FootballTransition.StatsCountYes,
        from: FootballState.StatsCount,
        to: FootballState.EndOfPlay
    },
    {
        // TODO: Is this correct? Going from penalty accepted to NoPenaltyEndOfPlay
        name: FootballTransition.NoPenaltyEndOfPlay,
        from: [
            FootballState.PlayPenaltyPenaltyAccepted,
            FootballState.PlayPenaltyPenaltyDeclined,
            FootballState.PlayPenaltyStatsCount,
            FootballState.PlayPenaltyNoPlay
        ],
        to: FootballState.NoPenaltyEndOfPlay
    },
    {
        name: FootballTransition.OutOfBounds,
        from: [
            FootballState.Rush,
            FootballState.FieldGoalFakeRun,
            FootballState.FumbleRecovered,
            FootballState.FumbleNotRecovered,
            FootballState.Continue,
            FootballState.Returned,
            FootballState.NoRecoveryKickReturn,
            FootballState.PassComplete,
            FootballState.PassIntercepted,
            FootballState.Lateral,
            FootballState.KickRecovered,
            FootballState.KickNotRecovered,
            FootballState.Fumble,
            FootballState.KickOff,
            // Indoor Football - Rebound Net and Bar Ball
            FootballState.ReboundNetCaughtOffense,
            FootballState.ReboundNetCaughtDefense,
            FootballState.ReboundNetFieldedKicking,
            FootballState.ReboundNetFieldedReceiving,
            FootballState.BarBallRecoveredKicking,
            FootballState.BarBallRecoveredReceiving,
            // Indoor Football - Deuce missed OOB
            FootballState.DeuceMissed
        ],
        to: FootballState.OutOfBounds
    },
    {
        name: FootballTransition.Fumble,
        from: [
            FootballState.Rush,
            FootballState.Run,
            FootballState.FieldGoalFakeRun,
            FootballState.FumbleRecovered,
            FootballState.FumbleNotRecovered,
            FootballState.Continue,
            FootballState.Returned,
            FootballState.NoRecoveryKickReturn,
            FootballState.PassComplete,
            FootballState.Tackle,
            FootballState.PassIntercepted,
            FootballState.Lateral,
            FootballState.KickRecovered,
            FootballState.KickNotRecovered,
            FootballState.PassSacked,
            FootballState.FieldGoalFakePass,
            FootballState.Pass,
            FootballState.PatPass,
            // Indoor Football - Rebound Net and Bar Ball
            FootballState.ReboundNetCaughtOffense,
            FootballState.ReboundNetCaughtDefense,
            FootballState.ReboundNetFieldedKicking,
            FootballState.ReboundNetFieldedReceiving,
            FootballState.BarBallRecoveredKicking,
            FootballState.BarBallRecoveredReceiving
        ],
        to: FootballState.Fumble
    },
    {
        name: FootballTransition.Muffed,
        from: [
            // TODO: Confirm this kicks.
            // FootballState.KickRecovered,
            // FootballState.KickNotRecovered,
            FootballState.Punt,
            FootballState.CflKick
        ],
        to: FootballState.Muffed
    },
    {
        name: FootballTransition.FumbleRecovered,
        from: [
            FootballState.Fumble,
            FootballState.FieldGoalFumble,
            FootballState.Muffed
        ],
        to: FootballState.FumbleRecovered
    },
    {
        name: FootballTransition.FumbleNotRecovered,
        from: [
            FootballState.Fumble,
            FootballState.FieldGoalFumble,
            FootballState.Muffed
        ],
        to: FootballState.FumbleNotRecovered
    },
    {
        name: FootballTransition.Tackle,
        from: [
            FootballState.Rush,
            FootballState.Run,
            FootballState.FieldGoalFakeRun,
            FootballState.FumbleRecovered,
            FootballState.FumbleNotRecovered,
            FootballState.Continue,
            FootballState.Returned,
            FootballState.NoRecoveryKickReturn,
            FootballState.KickRecovered,
            FootballState.KickNotRecovered,
            FootballState.PassComplete,
            FootballState.PassIntercepted,
            FootballState.Lateral,
            // Indoor Football - Rebound Net and Bar Ball
            FootballState.ReboundNetCaughtOffense,
            FootballState.ReboundNetCaughtDefense,
            FootballState.ReboundNetFieldedKicking,
            FootballState.ReboundNetFieldedReceiving,
            FootballState.BarBallRecoveredKicking,
            FootballState.BarBallRecoveredReceiving
        ],
        to: FootballState.Tackle
    },
    {
        name: FootballTransition.Continue,
        from: [
            FootballState.FumbleRecovered,
            FootballState.FumbleNotRecovered,
            FootballState.PassComplete,
            FootballState.KickRecovered,
            FootballState.Lateral,
            FootballState.FumbledSnapLost,
            // Indoor Football - Rebound Net and Bar Ball
            FootballState.ReboundNetCaughtOffense,
            FootballState.ReboundNetCaughtDefense,
            FootballState.ReboundNetFieldedKicking,
            FootballState.ReboundNetFieldedReceiving,
            FootballState.BarBallRecoveredKicking,
            FootballState.BarBallRecoveredReceiving
        ],
        to: FootballState.Continue
    },
    {
        name: FootballTransition.Returned,
        from: [
            FootballState.KickOff,
            FootballState.Punt,
            FootballState.CflKick,
            FootballState.FieldGoalMissed
        ],
        to: FootballState.Returned
    },
    {
        name: FootballTransition.NoRecoveryKickReturn,
        from: FootballState.KickNotRecovered,
        to: FootballState.NoRecoveryKickReturn
    },
    {
        name: FootballTransition.Finalize,
        from: [
            FootballState.EndOfPlay,
            FootballState.NoPenaltyEndOfPlay,
            FootballState.Timeout,
            FootballState.StartDrive,
            FootballState.GameStart,
            FootballState.StartPeriod,
            FootballState.UpdateContext,
            FootballState.SwapTeams,
            FootballState.CoinToss,
            FootballState.SetTimeAndPeriod,
            FootballState.SkipKickoff
        ],
        to: FootballState.Finalize
    },
    {
        name: FootballTransition.SkipKickoff,
        from: [FootballState.EndOfPlay],
        to: FootballState.SkipKickoff
    },
    //PENALTIES
    {
        name: FootballTransition.Penalty,
        from: FootballState.EndOfPlay,
        to: FootballState.Penalty
    },
    {
        name: FootballTransition.KickOffPenalty,
        from: FootballState.KickOff,
        to: FootballState.KickOffPenalty
    },
    {
        name: FootballTransition.PenaltyDeclined,
        from: [FootballState.Penalty, FootballState.SecondPenalty],
        to: FootballState.PenaltyDeclined
    },
    {
        name: FootballTransition.PenaltyAccepted,
        from: [FootballState.Penalty, FootballState.SecondPenalty],
        to: FootballState.PenaltyAccepted
    },
    {
        name: FootballTransition.Offsetting,
        from: [FootballState.Penalty, FootballState.KickOffPenalty],
        to: FootballState.Offsetting
    },
    {
        name: FootballTransition.SecondOffsetting,
        from: FootballState.SecondPenalty,
        to: FootballState.SecondOffsetting
    },
    {
        name: FootballTransition.SecondPenalty,
        from: FootballState.Offsetting,
        to: FootballState.SecondPenalty
    },
    {
        name: FootballTransition.StatsCount,
        from: [
            FootballState.PenaltyAccepted,
            FootballState.SecondOffsetting,
            FootballState.KickOffPenaltyAccepted
        ],
        to: FootballState.StatsCount
    },
    {
        name: FootballTransition.NoPlay,
        from: FootballState.StatsCount,
        to: FootballState.NoPlay
    },
    //PLAY PENALTIES
    {
        name: FootballTransition.PlayPenalty,
        from: [FootballState.AddPlay],
        to: FootballState.PlayPenalty
    },
    {
        name: FootballTransition.PlayPenaltyPenaltyDeclined,
        from: [
            FootballState.PlayPenalty,
            FootballState.PlayPenaltySecondPenalty
        ],
        to: FootballState.PlayPenaltyPenaltyDeclined
    },
    {
        name: FootballTransition.PlayPenaltyPenaltyAccepted,
        from: [
            FootballState.PlayPenalty,
            FootballState.PlayPenaltySecondPenalty
        ],
        to: FootballState.PlayPenaltyPenaltyAccepted
    },
    {
        name: FootballTransition.PlayPenaltyOffsetting,
        from: FootballState.PlayPenalty,
        to: FootballState.PlayPenaltyOffsetting
    },
    {
        name: FootballTransition.PlayPenaltySecondOffsetting,
        from: FootballState.PlayPenaltySecondPenalty,
        to: FootballState.PlayPenaltySecondOffsetting
    },
    {
        name: FootballTransition.PlayPenaltySecondPenalty,
        from: FootballState.PlayPenaltyOffsetting,
        to: FootballState.PlayPenaltySecondPenalty
    },
    {
        name: FootballTransition.PlayPenaltyNoPlay,
        from: FootballState.PlayPenaltyStatsCount,
        to: FootballState.PlayPenaltyNoPlay
    },
    {
        name: FootballTransition.PlayPenaltyStatsCount,
        from: FootballState.PlayPenaltySecondOffsetting,
        to: FootballState.PlayPenaltyStatsCount
    },
    //PAT
    {
        name: FootballTransition.PatTry,
        from: FootballState.AddPlay,
        to: FootballState.PatTry
    },
    // Drop Kick disabled - using isDropKick flag on PatKick/FieldGoal fragments instead
    // {
    //     name: FootballTransition.DropKick,
    //     from: FootballState.PatTry,
    //     to: FootballState.DropKick
    // },
    {
        name: FootballTransition.PatKick,
        from: FootballState.PatTry,
        to: FootballState.PatKick
    },
    {
        name: FootballTransition.PatPass,
        from: FootballState.PatTry,
        to: FootballState.PatPass
    },
    {
        name: FootballTransition.Run,
        from: FootballState.PatTry,
        to: FootballState.Run
    },
    {
        name: FootballTransition.PatBlocked,
        from: [FootballState.DropKick],
        to: FootballState.PatBlocked
    },
    {
        name: FootballTransition.PatReturned,
        from: [FootballState.PatNotRecovered, FootballState.PatIntercepted],
        to: FootballState.PatReturned
    },
    {
        name: FootballTransition.PatContinued,
        from: [FootballState.PatRecovered],
        to: FootballState.PatContinued
    },
    {
        name: FootballTransition.PatPointsAwarded,
        from: [FootballState.PatReturned, FootballState.PatContinued],
        to: FootballState.PatPointsAwarded
    },
    {
        name: FootballTransition.PatRecovered,
        from: [FootballState.PatBlocked, FootballState.PatFumbled],
        to: FootballState.PatRecovered
    },
    {
        name: FootballTransition.PatNotRecovered,
        from: [FootballState.PatBlocked, FootballState.PatFumbled],
        to: FootballState.PatNotRecovered
    },
    {
        name: FootballTransition.PatPointsNotAwarded,
        from: [FootballState.PatReturned, FootballState.PatContinued],
        to: FootballState.PatPointsNotAwarded
    },
    {
        name: FootballTransition.PatCompleted,
        from: [FootballState.DropKick],
        to: FootballState.PatCompleted
    },
    {
        name: FootballTransition.PatMissed,
        from: [FootballState.DropKick],
        to: FootballState.PatMissed
    },
    {
        name: FootballTransition.PatIntercepted,
        from: [FootballState.DropKick],
        to: FootballState.PatIntercepted
    },
    {
        name: FootballTransition.PatFumbled,
        from: [FootballState.DropKick],
        to: FootballState.PatFumbled
    },
    // KICK
    {
        name: FootballTransition.Kick,
        from: [FootballState.AddPlay, FootballState.FumbledSnapRecovered],
        to: FootballState.Kick
    },
    {
        name: FootballTransition.CflKick,
        from: [
            FootballState.Rush,
            FootballState.Run,
            FootballState.FumbleRecovered,
            FootballState.FumbleNotRecovered,
            FootballState.Continue,
            FootballState.Returned,
            FootballState.NoRecoveryKickReturn,
            FootballState.KickRecovered,
            FootballState.KickNotRecovered,
            FootballState.PassIntercepted,
            FootballState.PassComplete,
            FootballState.PassSacked,
            FootballState.Lateral
        ],
        to: FootballState.CflKick
    },
    {
        name: FootballTransition.KickOff,
        from: FootballState.Kick,
        to: FootballState.KickOff
    },
    // Deuce (Indoor Football - kickoff through uprights for 2 points)
    {
        name: FootballTransition.Deuce,
        from: FootballState.KickOff,
        to: FootballState.Deuce
    },
    {
        name: FootballTransition.DeuceGood,
        from: FootballState.Deuce,
        to: FootballState.DeuceGood
    },
    {
        name: FootballTransition.DeuceMissed,
        from: FootballState.Deuce,
        to: FootballState.DeuceMissed
    },
    // Rebound Net (Indoor Football - ball hits net and stays live)
    {
        name: FootballTransition.HitReboundNet,
        from: [
            FootballState.Pass,
            FootballState.FieldGoal,
            FootballState.KickOff,
            FootballState.PatKick
        ],
        to: FootballState.HitReboundNet
    },
    {
        name: FootballTransition.ReboundNetCaughtOffense,
        from: [FootballState.HitReboundNet, FootballState.HitGoalpost],
        to: FootballState.ReboundNetCaughtOffense
    },
    {
        name: FootballTransition.ReboundNetCaughtDefense,
        from: [FootballState.HitReboundNet, FootballState.HitGoalpost],
        to: FootballState.ReboundNetCaughtDefense
    },
    {
        name: FootballTransition.ReboundNetHitGround,
        from: [FootballState.HitReboundNet, FootballState.HitGoalpost],
        to: FootballState.ReboundNetHitGround
    },
    {
        name: FootballTransition.ReboundNetFieldedKicking,
        from: FootballState.HitReboundNet,
        to: FootballState.ReboundNetFieldedKicking
    },
    {
        name: FootballTransition.ReboundNetFieldedReceiving,
        from: FootballState.HitReboundNet,
        to: FootballState.ReboundNetFieldedReceiving
    },
    // Bar Ball (Indoor Football - kick hits goalpost on KO, FGA, or PAT)
    {
        name: FootballTransition.HitGoalpost,
        from: [
            FootballState.KickOff,
            FootballState.FieldGoal,
            FootballState.PatKick
        ],
        to: FootballState.HitGoalpost
    },
    {
        name: FootballTransition.BarBallRecoveredKicking,
        from: FootballState.HitGoalpost,
        to: FootballState.BarBallRecoveredKicking
    },
    {
        name: FootballTransition.BarBallRecoveredReceiving,
        from: FootballState.HitGoalpost,
        to: FootballState.BarBallRecoveredReceiving
    },
    {
        name: FootballTransition.FieldGoal,
        from: FootballState.Kick,
        to: FootballState.FieldGoal
    },
    {
        name: FootballTransition.FieldGoalFumble,
        from: [FootballState.FieldGoal, FootballState.PatKick],
        to: FootballState.FieldGoalFumble
    },
    {
        name: FootballTransition.FieldGoalFakeRun,
        from: [FootballState.FieldGoal, FootballState.PatKick],
        to: FootballState.FieldGoalFakeRun
    },
    {
        name: FootballTransition.FieldGoalFakePass,
        from: [FootballState.FieldGoal, FootballState.PatKick],
        to: FootballState.FieldGoalFakePass
    },
    {
        name: FootballTransition.FieldGoalGood,
        from: [FootballState.FieldGoal, FootballState.PatKick],
        to: FootballState.FieldGoalGood
    },
    {
        name: FootballTransition.FieldGoalMissed,
        from: [FootballState.FieldGoal, FootballState.PatKick],
        to: FootballState.FieldGoalMissed
    },
    {
        name: FootballTransition.FieldGoalBlocked,
        from: [FootballState.FieldGoal, FootballState.PatKick],
        to: FootballState.FieldGoalBlocked
    },
    {
        name: FootballTransition.Rouge,
        from: [
            FootballState.Tackle,
            FootballState.Continue,
            FootballState.Returned,
            FootballState.KickNotRecovered,
            FootballState.FumbleRecovered,
            FootballState.FumbleNotRecovered,
            FootballState.FairCatch,
            FootballState.Punt,
            FootballState.CflKick,
            FootballState.FieldGoalMissed,
            FootballState.KickOff
        ],
        to: FootballState.Rouge
    },
    {
        name: FootballTransition.Downed,
        from: FootballState.Punt,
        to: FootballState.Downed
    },
    {
        name: FootballTransition.TouchBack,
        from: [
            FootballState.KickOff,
            FootballState.Punt,
            FootballState.CflKick,
            FootballState.PuntBlocked,
            FootballState.Fumble,
            FootballState.FieldGoalMissed,
            FootballState.OutOfBounds
        ],
        to: FootballState.TouchBack
    },
    {
        name: FootballTransition.FairCatch,
        from: [
            FootballState.KickOff,
            FootballState.Punt,
            FootballState.CflKick
        ],
        to: FootballState.FairCatch
    },
    {
        name: FootballTransition.OnSide,
        from: FootballState.KickOff,
        to: FootballState.OnSide
    },
    {
        name: FootballTransition.KickRecovered,
        from: [
            FootballState.OnSide,
            FootballState.FieldGoalBlocked,
            FootballState.PuntBlocked
        ],
        to: FootballState.KickRecovered
    },
    {
        name: FootballTransition.KickNotRecovered,
        from: [
            FootballState.OnSide,
            FootballState.FieldGoalBlocked,
            FootballState.PuntBlocked
        ],
        to: FootballState.KickNotRecovered
    },
    //PUNT
    {
        name: FootballTransition.Punt,
        from: [FootballState.AddPlay, FootballState.FumbledSnapRecovered],
        to: FootballState.Punt
    },
    {
        name: FootballTransition.PuntOutOfBounds,
        from: [FootballState.Punt, FootballState.CflKick],
        to: FootballState.PuntOutOfBounds
    },
    {
        name: FootballTransition.FieldGoalOutOfBounds,
        from: [FootballState.FieldGoal],
        to: FootballState.FieldGoalOutOfBounds
    },
    {
        name: FootballTransition.PuntBlocked,
        from: [FootballState.Punt, FootballState.CflKick],
        to: FootballState.PuntBlocked
    },
    //PASS
    {
        name: FootballTransition.Pass,
        from: [FootballState.AddPlay, FootballState.FumbledSnapRecovered],
        to: FootballState.Pass
    },
    {
        name: FootballTransition.PassIncomplete,
        from: [
            FootballState.Pass,
            FootballState.FieldGoalFakePass,
            FootballState.PatPass
        ],
        to: FootballState.PassIncomplete
    },
    {
        name: FootballTransition.PassBrokenUp,
        from: [
            FootballState.Pass,
            FootballState.FieldGoalFakePass,
            FootballState.PatPass
        ],
        to: FootballState.PassBrokenUp
    },
    {
        name: FootballTransition.PassDropped,
        from: [
            FootballState.Pass,
            FootballState.FieldGoalFakePass,
            FootballState.PatPass
        ],
        to: FootballState.PassDropped
    },
    {
        name: FootballTransition.PassSacked,
        from: [
            FootballState.Pass,
            FootballState.FieldGoalFakePass,
            FootballState.PatPass
        ],
        to: FootballState.PassSacked
    },
    {
        name: FootballTransition.PassIntercepted,
        from: [
            FootballState.Pass,
            FootballState.FieldGoalFakePass,
            FootballState.PatPass
        ],
        to: FootballState.PassIntercepted
    },
    {
        name: FootballTransition.PassComplete,
        from: [
            FootballState.Pass,
            FootballState.FieldGoalFakePass,
            FootballState.PatPass
        ],
        to: FootballState.PassComplete
    },
    //GAME CONTROL
    {
        name: FootballTransition.GameControl,
        from: FootballState.AddPlay,
        to: FootballState.GameControl
    },
    {
        name: FootballTransition.StartDrive,
        from: FootballState.GameControl,
        to: FootballState.StartDrive
    },
    {
        name: FootballTransition.Timeout,
        from: FootballState.GameControl,
        to: FootballState.Timeout
    },
    {
        name: FootballTransition.GameStart,
        from: FootballState.GameControl,
        to: FootballState.GameStart
    },
    {
        name: FootballTransition.StartPeriod,
        from: FootballState.GameControl,
        to: FootballState.StartPeriod
    },
    {
        name: FootballTransition.UpdateContext,
        from: FootballState.GameControl,
        to: FootballState.UpdateContext
    },
    {
        name: FootballTransition.CoinToss,
        from: FootballState.GameControl,
        to: FootballState.CoinToss
    },
    {
        name: FootballTransition.SwapTeams,
        from: FootballState.GameControl,
        to: FootballState.SwapTeams
    },
    {
        name: FootballTransition.Lateral,
        from: [
            FootballState.Continue,
            FootballState.PassIntercepted,
            FootballState.PatIntercepted,
            FootballState.Rush,
            FootballState.Run,
            FootballState.Returned,
            FootballState.NoRecoveryKickReturn
        ],
        to: FootballState.Lateral
    },
    {
        name: FootballTransition.Safety,
        from: [
            FootballState.Tackle,
            FootballState.OutOfBounds,
            FootballState.FumbleRecovered,
            FootballState.FumbleNotRecovered,
            FootballState.PassSacked,
            FootballState.Continue
        ],
        to: FootballState.Safety
    },
    {
        name: FootballTransition.SetTimeAndPeriod,
        from: FootballState.GameControl,
        to: FootballState.SetTimeAndPeriod
    }
];

export default FootballTransitionConfig;
